import { render, staticRenderFns } from "./AuthSocialSignIn.vue?vue&type=template&id=165a59c8&scoped=true"
import script from "./AuthSocialSignIn.vue?vue&type=script&lang=js"
export * from "./AuthSocialSignIn.vue?vue&type=script&lang=js"
import style0 from "./AuthSocialSignIn.vue?vue&type=style&index=0&id=165a59c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165a59c8",
  null
  
)

export default component.exports